import request from '@/utils/request'
function Pagination(page, size) { // 分页参数
  this.page = page;
  this.pagesize = size;
  this.pageorder = 'string';
  this.pagesort = 'string'
}
function getPath(folders) {
  let path = '/'
  folders.forEach((folder) => {
    if (folder.path) {
      path += `${folder.path}/`
    }
  })
  return path
}
function getPaths(folders, multiSelection, withNum) {
  let paths = []
  let path

  let f = folders
  if (multiSelection && multiSelection.selectAll) {
    if (folders.length == 1) {
      if (withNum) {
        paths.push({
          path: '/',
          num: multiSelection.total
        })
      } else {
        paths.push({
          path: '/',
        })
      }
    } else {
      // f = folders.slice(0, folders.length - 1)
      path = getPath(f)
      if (withNum) {
        paths.push({
          bid: f[f.length - 1].bid,
          path: path,
          num: multiSelection.total
        })
      } else {
        paths.push({
          bid: f[f.length - 1].bid,
          path: path
        })
      }
    }
  } else {
    path = getPath(folders)
    multiSelection.selection.forEach((select) => {
      // console.log(select)
      let cPath = path
      if (select.path) {
        cPath += `${select.path}/`
      }
      if (withNum) {
        paths.push({
          bid: select.bid,
          path: cPath,
          num: select.cnt || 1
        })
      } else {
        paths.push({
          bid: select.bid,
          path: cPath,
        })
      }
      if (select.id) {
        paths[paths.length - 1].lid = select.id
      }
    })
  }
  return paths
}
// 获取结算项目列表
export function getProjectList(pid, vid, page, size) {
  return request({
    url: '/v1/mgr/safe/annotate/validate/project/settlement/new/settle/base/query_project_budget_brief_list',
    method: 'post',
    data: {
      pid: pid, // 任务流ID
      vid: vid, // 项目ID
      ...new Pagination(page, size)
    }
  })
}

// 任务流结算数据总览
export function getProjectFolderList(pid, type, path, page, size) {
  return request({
    url: '/v1/mgr/safe/annotate/validate/project/settlement/new/settle/base/query_transfer_settle_list',
    method: 'post',
    data: {
      pid: pid, // 任务流ID
      queryType: type, // 数据类型
      path: path, // 路径
      ...new Pagination(page, size)
    }
  })
}
//结算包列表
export function getSettleList(pid, vid, status, page, size) {
  return request({
    url: '/v1/mgr/safe/annotate/validate/project/settlement/new/settle/base/query_settle_base_list',
    method: 'post',
    data: {
      pid: pid, // 任务流ID
      vid: vid, // 项目ID
      status: status, // 路径
      ...new Pagination(page, size)
    }
  })
}
// 根据结算包ID查询结算包题目列表
export function getSettleData(id) {
  return request({
    url: '/v1/mgr/safe/annotate/validate/project/settlement/new/settle/base/query_settle_base_libs_detail_list',
    method: 'post',
    data: {
      settleBaseId: id, // 结算包Id
    }
  })
}
// 创建结算包
export function createSettleData(pid,folders,multiSelection,number,preSettleApplyId) {
  let paths = getPaths(folders, multiSelection, true)
  return request({
    url: '/v1/mgr/safe/annotate/validate/project/settlement/settle/tags/libs/create_settle_base',
    method: 'post',
    data: {
      pid: pid, // 任务流ID
      num: number,
      paths: paths,
      preSettleApplyId:preSettleApplyId // 批次
    }
  })
}
// 取消结算包
export function cancelSettleData(pid,id) {
  return request({
    url: '/v1/mgr/safe/annotate/validate/project/settlement/settle/tags/libs/cancel_settle_base',
    method: 'post',
    data: {
      pid: pid, // 任务流ID
      settleBaseId: id, // 结算包Id
    }
  })
}

// 修改结算包的别名
export function renameSettle(pid,id,name) {
  return request({
    url: '/v1/mgr/safe/annotate/validate/project/settlement/settle/tags/libs/modify_settle_base_remark_name',
    method: 'post',
    data: {
      pid: pid, // 任务流ID
      settleBaseId: id, // 结算包Id
      baseRemarkName : name
    }
  })
}

// 导出结算包
export function exportSettleData(pid,id) {
  return request({
    url: '/v1/mgr/safe/annotate/validate/project/settlement/settle/tags/libs/query_settle_base_info',
    method: 'post',
    data: {
      pid: pid, // 任务流ID
      settleBaseId: id, // 结算包Id
    }
  })
}

// 获取项目批次列表
export function getSettleApplyList(pid) {
  return request({
    url: '/v1/mgr/safe/annotate/validate/project/settlement/settle/tags/libs/query/pre_settle_apply_detail_list',
    method: 'post',
    data: {
      pid: pid, // 任务流ID
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/settle.js